// Same rules as api-dsh (authentication_service/common), checked first so the
// user sees the mistake before a request (and before an SMS is sent).

export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_MAX_LENGTH = 64;
const USERNAME_PATTERN = /^[A-Za-z0-9_.]{3,30}$/;
const EMAIL_PATTERN = /^[^@\s]+@[^@\s]+\.[^@\s]+$/;

export const passwordError = (password: string): string | undefined => {
  if (!password) return 'Password wajib diisi.';
  if (password.length < PASSWORD_MIN_LENGTH || password.length > PASSWORD_MAX_LENGTH) {
    return `Password harus ${PASSWORD_MIN_LENGTH}-${PASSWORD_MAX_LENGTH} karakter.`;
  }
  if (!/[A-Za-z]/.test(password) || !/\d/.test(password)) {
    return 'Password harus berisi huruf dan angka.';
  }
  return undefined;
};

export const usernameError = (username: string): string | undefined => {
  if (!username.trim()) return 'Username wajib diisi.';
  if (!USERNAME_PATTERN.test(username.trim())) {
    return 'Username 3-30 karakter: huruf, angka, titik atau garis bawah.';
  }
  return undefined;
};

export const emailError = (email: string): string | undefined => {
  if (!email.trim()) return 'Alamat email wajib diisi.';
  if (!EMAIL_PATTERN.test(email.trim())) return 'Alamat email tidak valid.';
  return undefined;
};

/** YYYY-MM-DD from a date input: required, not in the future. */
export const birthDateError = (value: string): string | undefined => {
  if (!value) return 'Tanggal lahir wajib diisi.';
  const today = new Date().toISOString().slice(0, 10);
  if (value > today || value < '1900-01-01') return 'Tanggal lahir tidak valid.';
  return undefined;
};
